








































































import InstrumentContainer from "./components/InstrumentContainer.vue";
import { Component, Vue } from "vue-property-decorator";

import { mdiPiano, mdiGiftOutline } from "@mdi/js";

@Component({
  components: {
    InstrumentContainer
  }
})
export default class App extends Vue {
  name = "App";

  pianoIcon = mdiPiano;
  giftIcon = mdiGiftOutline;
  drawer = false;
}
